<template>
  <v-container fluid grid-list-lg text-center class="ax-corps mb-4">
    <!--<h1>This is AX-corps</h1>-->
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-layout row wrap>

          <v-flex xs12>
            <v-card class="card-style text-center pa-3">
              <h2>AX Корпус EG Pilots</h2>
              <p class="lead">Вследствие агрессивного поведения Таргоидов и возрастающей угрозы мирному населению обжитой части космоса, в совокупности с полным отсутствием возможности выйти с инопланетянами на мирный контакт, 15 апреля 3304 года руководством фракции EG Pilots было принято решение о создании AX Корпуса. Его основной целью является защита людей от атак Таргоидов во всех уголках Галактики и обучение пилотов искусству ведения боя с различными типами кораблей пришельцев. </p>
              <br>
              <p class="lead">АХ Корпус EG Pilots входит в Триумвират - военный союз анти-инопланетных отделений крупнейших русскоязычных сообществ.</p>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="card-style text-center pa-3">
              <h2>Орлиный Глаз</h2> <!-- eagleEye -->
              <v-container fluid>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs12 sm12 md5>
                    <v-img class="my-1 mx-auto rounded" 
                    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vRYliX95wc9LngIwHo3_ZhIDYw8H73rRQc_n162EhVbP0IJFQF68P8kBKD6zvqVS64IanGp7Exasgey/pubchart?oid=1511173836&amp;format=image" 
                    aspect-ratio="1" contain
                    alt="Название системы" 
                    crossorigin="anonymous" />
                    <!--  -->
                    <!-- :lazy-src="require('@/assets/animate-logo-white.svg')" -->
                    <!-- <img class="image rounded" alt="Название системы" :src="eagleEye.systemSrc" crossorigin="anonymous"> -->
                  </v-flex>
                  <v-flex xs12 sm12 md5>
                    <v-img class="my-1 mx-auto rounded" 
                    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vRYliX95wc9LngIwHo3_ZhIDYw8H73rRQc_n162EhVbP0IJFQF68P8kBKD6zvqVS64IanGp7Exasgey/pubchart?oid=1016656619&amp;format=image" 
                    aspect-ratio="1" contain
                    alt="Состояние" 
                    crossorigin="anonymous" />
                    <!-- <img class="image rounded" alt="Состояние" :src="eagleEye.stateSrc" crossorigin="anonymous"> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="card-style text-center pa-3">
              <h2>Статистика обороняемых систем</h2> <!-- statisticsDefensibleSystems -->
              <v-container fluid>
                <v-layout justify-center row wrap>
                  <v-img class="rounded" 
                  src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1846358376&amp;format=image" 
                  alt="Статистика обороняемых систем" 
                  crossorigin="anonymous" />
                  <!-- <img class="rounded" alt="Статистика обороняемых систем" :src="statisticsDefensibleSystems.primary" crossorigin="anonymous"> -->
                </v-layout>
              </v-container>
              <!-- Модальное окно -->
              <v-dialog dark pa-2 v-model="dialog">
                <template v-slot:activator="{ on }">
                  <v-btn block outlined dark v-on="on">Подробная информация</v-btn>
                </template>
                <v-card>
                  <v-container>
                    <!-- <v-layout justify-center row wrap v-for="(item, i) in statisticsDefensibleSystems.detail" :key="i">
                      <img class="rounded" :src="item" :alt="i" crossorigin="anonymous">
                      <hr>
                    </v-layout> -->
                    <v-img class="rounded" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=665435912&amp;format=image" alt="1" crossorigin="anonymous" />
                    <br>
                    <hr>
                    <br>
                    <v-img class="rounded" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1111389601&amp;format=image" alt="2" crossorigin="anonymous" />
                    <br>
                    <hr>
                    <br>
                    <v-img class="rounded" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1290486743&amp;format=image" alt="3" crossorigin="anonymous" />
                    <br>
                    <hr>
                    <br>
                    <v-img class="rounded" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1089119202&amp;format=image" alt="4" crossorigin="anonymous" />
                    <br>
                    <hr>
                    <br>
                    <v-img class="rounded" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=125741078&amp;format=image" alt="5" crossorigin="anonymous" />
                    <br>
                    <hr>
                    <br>
                    <v-img class="rounded" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=390124452&amp;format=image" alt="6" crossorigin="anonymous" />
                  </v-container>
                </v-card>
              </v-dialog>
              <!--  -->
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="card-style text-center pa-3">
              <h2>Лучшие AX пилоты</h2> <!-- bestPilot -->
                <v-tabs dark color="#00b8d4" centered grow>
                  <!-- <v-tabs-slider color="warning"></v-tabs-slider> -->
                  <v-tab href="#forAllTime">За всё время</v-tab>
                  <v-tab href="#perMonth">За месяц</v-tab>
                  <v-tab href="#forWeek">За неделю</v-tab>
                  <!--  -->
                  <v-tab-item :value="'forAllTime'">
                    <v-card flat>
                      <v-img class="rounded" 
                      src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=2009674101&amp;format=image" 
                      alt="За всё время" 
                      crossorigin="anonymous" />
                    </v-card>
                  </v-tab-item>
                  <v-tab-item :value="'perMonth'">
                    <v-card flat>
                      <v-img class="rounded" 
                      src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1551613102&amp;format=image" 
                      alt="За месяц" 
                      crossorigin="anonymous" />
                    </v-card>
                  </v-tab-item>
                  <v-tab-item :value="'forWeek'">
                    <v-card flat>
                      <v-img class="rounded" 
                      src="https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=2003005621&amp;format=image"
                      alt="За неделю" 
                      crossorigin="anonymous" />
                    </v-card>
                  </v-tab-item>
                </v-tabs>


                <!-- <v-tabs dark color="#00b8d4" centered grow>
                    <v-tabs-slider color="warning"></v-tabs-slider>
                    <v-tab v-for="(item,i) in bestPilot" 
                    :key="i" 
                    :href="'#'+item.href">
                        {{ item.title }}
                    </v-tab>
                    <v-tabs-items>
                        <v-tab-item v-for="(item,i) in bestPilot" 
                        :key="i" 
                        :value="item.href">
                            <v-card flat>
                                <img class="rounded" :src="item.src" :alt="item.title" crossorigin="anonymous">
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs> -->
            </v-card>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
    data: () => ({
        dialog: false,
        /*
        eagleEye: {
            systemSrc: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRYliX95wc9LngIwHo3_ZhIDYw8H73rRQc_n162EhVbP0IJFQF68P8kBKD6zvqVS64IanGp7Exasgey/pubchart?oid=1511173836&amp;format=image",
            stateSrc: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRYliX95wc9LngIwHo3_ZhIDYw8H73rRQc_n162EhVbP0IJFQF68P8kBKD6zvqVS64IanGp7Exasgey/pubchart?oid=1016656619&amp;format=image"
        },
        statisticsDefensibleSystems: {
            primary: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1846358376&amp;format=image',
            detail: [
                'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=665435912&amp;format=image',
                'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1111389601&amp;format=image',
                'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1290486743&amp;format=image',
                'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1089119202&amp;format=image',
                'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=125741078&amp;format=image',
                'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=390124452&amp;format=image'
                ]
        },
        bestPilot: [
            {
                title: 'За всё время',
                href: 'forAllTime',
                src: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=2009674101&amp;format=image'},
            {
                title: 'За месяц',
                href: 'perMonth',
                src: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=1551613102&amp;format=image'},
            {
                title: 'За неделю',
                href: 'forWeek',
                src: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vScsozhoEgZ4OGAuSHBBtKW0DMMU1F1B2fTpCEuh-umubwyT6YJzOftqCykeQ7Jm5LvS5Xxi23wOi7k/pubchart?oid=2003005621&amp;format=image'}
                ]
        */
    })
}
</script>